import React from 'react';
const InvertableThemeContext = React.createContext({
    options: {},
});
export default InvertableThemeContext;
//# sourceMappingURL=InvertableThemeContext.js.map